import { render, staticRenderFns } from "./Magnitude.vue?vue&type=template&id=3c6f7ef3&"
import script from "./Magnitude.vue?vue&type=script&lang=js&"
export * from "./Magnitude.vue?vue&type=script&lang=js&"
import style0 from "./Magnitude.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports